import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c233fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-shadow" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "启用阴影：", -1))
const _hoisted_4 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "水平阴影：", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "垂直阴影：", -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "模糊距离：", -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "阴影颜色：", -1))

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTElementShadow } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from './ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import {
  Popover,
  Slider,
  Switch,
} from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementShadow',
  setup(__props) {

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const shadow = ref<PPTElementShadow>()
const hasShadow = ref(false)

watch(handleElement, () => {
  if (!handleElement.value) return
  shadow.value = 'shadow' in handleElement.value ? handleElement.value.shadow : undefined
  hasShadow.value = !!shadow.value
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateShadow = (shadowProps: Partial<PPTElementShadow>) => {
  if (!handleElement.value || !shadow.value) return
  const _shadow = { ...shadow.value, ...shadowProps }
  slidesStore.updateElement({ id: handleElement.value.id, props: { shadow: _shadow } })
  addHistorySnapshot()
}

const toggleShadow = (checked: boolean) => {
  if (!handleElement.value) return
  if (checked) {
    const _shadow: PPTElementShadow = { h: 1, v: 1, blur: 2, color: '#000' }
    slidesStore.updateElement({ id: handleElement.value.id, props: { shadow: _shadow } })
  }
  else {
    slidesStore.removeElementProps({ id: handleElement.value.id, propName: 'shadow' })
  }
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Switch), {
          checked: hasShadow.value,
          onChange: _cache[0] || (_cache[0] = checked => toggleShadow(checked as boolean))
        }, null, 8, ["checked"])
      ])
    ]),
    (hasShadow.value && shadow.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(Slider), {
              class: "slider",
              min: -10,
              max: 10,
              step: 1,
              value: shadow.value.h,
              onChange: _cache[1] || (_cache[1] = value => updateShadow({ h: value as number }))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_unref(Slider), {
              class: "slider",
              min: -10,
              max: 10,
              step: 1,
              value: shadow.value.v,
              onChange: _cache[2] || (_cache[2] = value => updateShadow({ v: value as number }))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_unref(Slider), {
              class: "slider",
              min: 1,
              max: 20,
              step: 1,
              value: shadow.value.blur,
              onChange: _cache[3] || (_cache[3] = value => updateShadow({ blur: value as number }))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_unref(Popover), { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: shadow.value.color,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = value => updateShadow({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: shadow.value.color,
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})